export { default } from './bindActionCreators';
